import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class IntegrationEvent extends Resource {
    public override type = 'integrationEvents';

    @prop()
    @required()
    public integrationId!: string;

    @prop()
    @required()
    public source: string = "CaseLog";

    @prop()
    @required()
    public sourceId!: string;

    @prop()
    public data!: string;
    
    @prop()
    public tries: number = 0;

    @prop()
    public isSuccess: boolean = false;

    @prop()
    public statusDate!: Date;

    @prop()
    public status: string = "pending";

}